// extracted by mini-css-extract-plugin
export default {"highchartsSankeyChartContainer":"highcharts-sankey-chart-container__highcharts-sankey-chart-container__NNWXw"};